import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, Form, Space, Tooltip } from 'antd'
import get from 'lodash.get'
import React, { useEffect, useState } from 'react'
import { hasPermission } from '../../config-func'
import { ACTION_MODE, OPTIONS_CODE, PAGE_SIZE_OPTIONS } from '../../configData'
import {
  configAdd,
  configUpdate,
  deleteConfig,
  detailConfig,
  getConfig
} from '../../services/centerService'
import Card from '../Card'
import ModalCustom from '../common/Modal/ModalCustom'
import ModalConfirm, { showConfirm } from '../common/ModalConfirm/ModalConfirm'
import openNotification from '../common/Notification/openNotification '
import TableField from '../common/Table/TableField'
import FilterForm from './FilterForm'
import FormPost from './FormPost'
import { departmentSearch } from '../../services/cmsservice'
import Loading from '../Loading';
const CenterInfo = () => {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [mode, setMode] = useState(ACTION_MODE.VIEW)
  const [form] = Form.useForm()
  const [dataSource, setDataSource] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)

  const [filters, setFilters] = useState({
    currentPage: 1,
    pageSize: 1000
  })

  const handleSearch = () => {
    if (filters.currentPage === 1) {
      fetchData()
    } else {
      setFilters((prev) => ({ ...prev, currentPage: 1 }))
    }
  }

  async function fetchData() {
    setLoading(true)
    let _dataSource = []
    let _total = 0

    const params = {
      page: filters.currentPage,
      pageSize: filters.pageSize
    }

    const cleanedData = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => value !== '' && value !== null && value !== undefined
      )
    )

    try {
      const response = await getConfig(cleanedData)
      _total = response?.data?.total
      _dataSource = response?.data?.list
      // }
    } catch (error) {
      openNotification('error', error?.response?.data?.message)
      console.error(error)
    } finally {
      setLoading(false)
      setTotal(_total)
      setDataSource(_dataSource)
    }
  }

  useEffect(() => {
    fetchData()
  }, [filters.currentPage, filters.pageSize, filters.reset])
  // -=0-=0-====================================================================================================
  // Columns for Table
  const initialColumns = [
    {
      title: 'STT',
      dataIndex: 'stt',
      key: 'stt',
      fixed: 'left',
      width: 60,
      align: 'center',
      render: (_, __, index) =>
        (filters.currentPage - 1) * filters.pageSize + index + 1
    },
    {
      title: 'Mục',
      dataIndex: 'code',
      key: 'code',
      render: (_, record) => {
        const item = OPTIONS_CODE.find(({ value }) => value === record.code)
        return item ? <span>{item.name}</span> : null
      }
    },
    {
      title: 'Tên file',
      dataIndex: 'value',
      key: 'value',
      render: (_, record) => {
        if (record.code === 'DEPARTMENT') {
          return <span>{listDepartmentFull.find(item => item.id == record.value)?.name || record.value}</span>
        }

          return (
            <div style={{maxWidth: 400,
                whiteSpace: 'normal',
                wordWrap: 'break-word',
                overflowWrap: 'break-word'}}>
              {record.value}
            </div>
          )

        // return <span>{record.value}</span>
      }
    },
    { title: 'Loại', dataIndex: 'type', key: 'type' },
    // {
    //   title: 'Trạng thái',
    //   dataIndex: 'status',
    //   key: 'status',
    //   render: (_, record) => <Switch checked={record.status === 1} />
    // },

    {
      title: 'Hành động',
      key: 'status',
      fixed: 'right',
      render: (_, record) => {
        return (
          <Space size="small">
            <>
              {hasPermission('P62.2', permissions) && (
                <Tooltip title="Chỉnh sửa">
                  <Button
                    style={{ width: 32 }}
                    icon={<EditOutlined />}
                    onClick={() => {
                      setMode(ACTION_MODE.UPDATE)
                      getDetailConfig(record.id)
                    }}
                  />
                </Tooltip>
              )}
              {hasPermission('P62.3', permissions) && (
                <Tooltip title="Xóa">
                  <Button
                    style={{ width: 32 }}
                    icon={<DeleteOutlined style={{ color: 'red' }} />}
                    onClick={() =>
                      showConfirm({
                        title: 'Xác nhận xóa',
                        content: (
                          <div>
                            Bạn có chắc chắn muốn xóa <b>{record.name}</b>
                          </div>
                        ),
                        onOk: () => handleDelete(record.id)
                      })
                    }
                  />
                </Tooltip>
              )}
            </>
          </Space>
        )
      }
    }
  ]

  // Thêm sửa project
  const handleSave = async () => {
    setLoading(true)
    try {
      // Validate các trường trong form
      const values = await form.validateFields()
      // Kiểm tra nếu cả hai giá trị đều tồn tại
      const { id, ...data } = values
      if (values.type == 'STK') {
        data.value = JSON.stringify({
          accountName: values.account_holder,
          accountNumber: values.account_number,
          bankName: values.bank_name
        })
      }else if (values.code == 'USER_ACCESS') {
        data.value = values.user_access.join(',')
      }

      const res =
        mode == ACTION_MODE.ADD
          ? await configAdd(data)
          : await configUpdate({ ...data, id })
      if (res.status == 200) {
        form.resetFields()
        setDetail(null)
        setIsModalOpen(false)
        fetchData()
        openNotification(
          'success',
          mode == ACTION_MODE.ADD
            ? 'Tạo mới thành công !'
            : 'Cập nhật thành công !'
        )
      } else {
        openNotification('error', res.message)
      }
    } catch (err) {
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  const [detail, setDetail] = useState(null)
  // Chi tiết dự án
  const getDetailConfig = async (id) => {
    setLoading(true)
    try {
      const res = await detailConfig(id) // Assuming roleSearch is an API function

      if (res && res.data) {
        setIsModalOpen(true)
        const values = res.data
        setDetail(values)
      } else {
        openNotification('error', 'Có lỗi xảy ra, Vui lòng thử lại')
      }
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  // Xóa project
  const handleDelete = async (ids) => {
    // const body = {
    //   ids: [ids]
    // }
    setLoading(true)
    try {
      const res = await deleteConfig(ids)

      console.log('res', res)
      if (res.status === 200) {
        fetchData()
        openNotification('success', 'Xóa thành công !')
      } else {
        openNotification('error', res.message)
      }
    } catch (err) {
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  const [listDepartmentFull, setListDepartmentFull] = useState([])
  const getDepartmentFull = async (values) => {
    // const d_id = localStorage.getItem('department_id')
    setLoading(true)
    let { name = '', type = '', page = 1, pageSize = 1000 } = values || {}
    try {
      const body = { name: name.trim(), type, page, pageSize }
      const res = await departmentSearch(body)
      const filteredData = res.data?.list;
      
      setListDepartmentFull(filteredData)

    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Có lỗi xảy ra, vui lòng thử lại')
    } finally {
      setLoading(false)
    }
  } 

  useEffect(() => {
    getDepartmentFull()
  }, [])
  //
  return (
    <div>
      <Loading loading={loading} />
      {/* <Card className="mb-2">
        <FilterForm
          handleSearch={handleSearch}
          setFilters={setFilters}
          fetchData={fetchData}
        />
      </Card> */}

      <Card>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            margin: '0px 50px 10px 0px',
            width: '100%'
          }}
        >
          {/* <h2 className="text-2xl font-semibold my-2">Quản lý dự án</h2> */}
          <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
            {/* <Button
              type="primary"
              key="primary"
              onClick={() => {
                setIsModalImportOpen(true)
              }}
            >
              <PlusOutlined /> Import Excel
            </Button> */}
            {hasPermission('P62.1', permissions) && (
              <Button
                type="primary"
                // htmlType="submit"
                onClick={() => {
                  setIsModalOpen(true)
                  setMode(ACTION_MODE.ADD)
                }}
              >
                <PlusOutlined />
                Thêm mới
              </Button>
            )}
          </div>
        </div>
        <TableField
          loading={loading}
          columns={initialColumns}
          dataSource={dataSource}
          scroll={{ x: 'max-content', y: 'calc(100vh - 400px)' }}
          className={`custom-table`}
          // locale={{
          //   emptyText: <Empty description="Không có dữ liệu" />, // Hiển thị "Không có dữ liệu" khi bảng không có dữ liệu
          //   triggerDesc: 'Sắp xếp giảm dần', // Khi click vào cột để sort giảm dần
          //   triggerAsc: 'Sắp xếp tăng dần', // Khi click vào cột để sort tăng dần
          //   cancelSort: 'Hủy sắp xếp' // Khi bỏ sắp xếp
          // }}

          // columns={
          //   filters.isDefault === 'fixed'
          //     ? columns.filter(
          //         (item) => !['calculationMethod'].includes(item.dataIndex)
          //       )
          //     : columns.filter(
          //         (item) => !['isDefault'].includes(item.dataIndex)
          //       )
          // }

          pagination={{
            current: filters.currentPage,
            pageSize: filters.pageSize,
            total: total,
            pageSizeOptions: PAGE_SIZE_OPTIONS,
            showSizeChanger: true,
            onShowSizeChange: (current, size) => {
              setFilters((prev) => ({
                ...prev,
                pageSize: size,
                currentPage: 1
              }))
            },
            onChange: (page) => {
              setFilters((prev) => ({ ...prev, currentPage: page }))
            },
            showTotal: (total, range) =>
              `Hiển thị ${range[0]}-${range[1]} của ${total} bản ghi`,
            locale: { items_per_page: 'bản ghi / trang' }
          }}
          rowKey={(record, index) => index}
          locale={{ emptyText: 'Không có dữ liệu' }}
        />
      </Card>
      {/* Modal Thêm mới sản phẩm */}
      <ModalCustom
        title={
          mode == ACTION_MODE.UPDATE
            ? 'Chỉnh sửa thông tin'
            : mode == 'ADD'
            ? 'Thêm mới thông tin'
            : 'Xem chi tiết'
        }
        visible={isModalOpen}
        centered
        onCancel={() => {
          setIsModalOpen(false)
          form.resetFields()
          setDetail(null)
        }}
        onConfirm={async () => {
          try {
            await form.validateFields() // Kiểm tra validation trước khi tiếp tục
            handleSave() // Nếu hợp lệ thì tiếp tục xử lý
          } catch (error) {
            console.log('Validation failed:', error)
          }
        }}
        confirmText={'Lưu'}
        cancelText="Đóng"
        footer={mode == 'VIEW' ? [''] : ''}
      >
        <FormPost
          data={detail}
          form={form}
          handleSearch={handleSearch}
          mode={mode}
          listDepartmentFull={listDepartmentFull}
        />
      </ModalCustom>
      <ModalConfirm />
    </div>
  )
}

export default CenterInfo
